// import $ from "jquery";
import { Modal } from "bootstrap";

export const init = () => {
  // let attempts = 0;

  document.querySelectorAll(".modal").forEach((modal) => {
    new Modal(modal);
  });

  // // if document.ready needed
  // const whenComplete = () => {
  //   if (attempts > 30) return;
  //   attempts += 1;
  //   if (document.readyState === "complete") {
  //     // --- code ---
  //   } else {
  //     setTimeout(function () {
  //       whenComplete();
  //     }, 400);
  //   }
  // };
  // whenComplete();
};
